<div class="flex flex-col gap-6">
  @if (currentView() === 0) {
    <div class="flex w-full justify-between mt-6 border-b border-neutral-300 sticky top-0 bg-white py-4 z-50">
      <span class="text-[18px] font-black">
        <i
          class="pi pi-file-edit"
          style="font-size: 2rem"></i>
        SUBSANACION DE DESPLIEGUE DE SISTEMA
      </span>

      <div class="flex gap-4">
        <app-buttons
          [label]="'Cancelar'"
          (click)="backPage()" />

        @if (!loading() && !errorMessage() && detailDeploySystem() && correctionFormData()) {
          <app-buttons
            [label]="startCorrectionLabel()"
            (click)="startCorrection()" />
        }
      </div>
    </div>
  }

  <div
    *ngIf="loading()"
    class="py-6 text-[16px] text-neutral-dark">
    Cargando detalle de subsanacion...
  </div>

  <div
    *ngIf="!loading() && errorMessage()"
    class="border-2 border-alert-base bg-neutral-100 rounded-sm px-6 py-4 flex items-start gap-3">
    <img
      src="assets/svg/alert.svg"
      alt="alert"
      class="w-4 h-4 mt-1" />
    <div class="flex flex-col">
      <span class="font-bold text-base">No se puede abrir la subsanacion</span>
      <span class="text-sm mt-1">{{ errorMessage() }}</span>
    </div>
  </div>

  <ng-container *ngIf="!loading() && !errorMessage() && detailDeploySystem() && correctionFormData()">
    @switch (currentView()) {
      @case (0) {
        <section class="flex flex-col gap-6 py-4">
          <div class="flex flex-col gap-3">
            <span class="text-[24px] font-bold">
              {{ detailDeploySystem()?.systemName || '-' }}
            </span>
            <p class="text-[16px] text-neutral-dark max-w-[920px]">
              Revisa los campos del despliegue del sistema que requieren correccion. Los campos solicitados para
              subsanar se marcaran en los pasos correspondientes del formulario. Para poder enviar de nuevo el
              despliegue a aprobacion, deberas revisar y corregir todos los campos indicados.
            </p>
          </div>

          <div class="border-2 border-alert-base bg-neutral-100 rounded-sm px-6 py-4 flex items-start gap-3">
            <img
              src="assets/svg/alert.svg"
              alt="alert"
              class="w-4 h-4 mt-1" />
            <div class="flex flex-col gap-4 w-full">
              <div class="flex flex-col">
                <span class="font-bold text-base">Despliegue del sistema pendiente de subsanacion</span>
                <span class="text-sm mt-1">
                  Se ha solicitado subsanar {{ correctionFieldsCount() === 1 ? 'el siguiente' : 'los siguientes' }}
                  <strong>{{ correctionFieldsCount() }}</strong>
                  {{ correctionFieldsCount() === 1 ? 'campo' : 'campos' }} del despliegue del sistema:
                </span>
              </div>

              @if (correctionFieldsSummary().length) {
                <div class="flex flex-col gap-3">
                  <div class="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-4">
                    @for (column of correctionFieldsSummaryColumns(); track $index) {
                      <div class="flex flex-col gap-4">
                        @for (group of column; track group.step) {
                          <div class="flex flex-col gap-1">
                            <span class="text-sm font-semibold">Paso {{ group.step }} - {{ group.stepLabel }}</span>

                            <ul class="list-disc pl-5 text-sm text-neutral-dark">
                              @for (field of group.fields; track field.formField) {
                                <li>{{ field.label }}</li>
                              }
                            </ul>
                          </div>
                        }
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          </div>

          <app-review-comments-block [comments]="reviewComments"></app-review-comments-block>
        </section>
      }

      @case (1) {
        <app-deploy-system-correction-step-1
          [existingData]="correctionFormData() ?? undefined"
          [observedFields]="observedFields()"
          [pendingObservedFields]="pendingObservedFields()"
          (observedFieldStatusChanged)="onObservedFieldStatusChanged($event)"
          (summaryRequested)="onStep1SummaryRequested($event)"
          (stepCompleted)="onStep1Completed($event)" />
      }

      @case (2) {
        <app-deploy-system-correction-step-2
          [existingData]="correctionFormData() ?? undefined"
          [observedFields]="observedFields()"
          [pendingObservedFields]="pendingObservedFields()"
          (goToPreviousStep)="goToPreviousStep(1, $event)"
          (observedFieldStatusChanged)="onObservedFieldStatusChanged($event)"
          (summaryRequested)="onStep2SummaryRequested($event)"
          (stepCompleted)="onStep2Completed($event)" />
      }

      @case (3) {
        <app-deploy-system-correction-step-3
          [existingData]="correctionFormData() ?? undefined"
          [observedFields]="observedFields()"
          [pendingObservedFields]="pendingObservedFields()"
          (goToPreviousStep)="goToPreviousStep(2, $event)"
          (observedFieldStatusChanged)="onObservedFieldStatusChanged($event)"
          (summaryRequested)="onStep3SummaryRequested($event)"
          (stepCompleted)="onStep3Completed($event)" />
      }

      @case (4) {
        <app-deploy-system-correction-step-4
          [existingData]="correctionFormData() ?? undefined"
          [observedFields]="observedFields()"
          [pendingObservedFields]="pendingObservedFields()"
          (goToPreviousStep)="goToPreviousStep(3, $event)"
          (observedFieldStatusChanged)="onObservedFieldStatusChanged($event)"
          (summaryRequested)="onStep4SummaryRequested($event)"
          (stepCompleted)="onStep4Completed($event)" />
      }

      @case (5) {
        <app-deploy-system-correction-step-5
          [existingData]="correctionFormData() ?? undefined"
          [observedFields]="observedFields()"
          [pendingObservedFields]="pendingObservedFields()"
          (goToPreviousStep)="goToPreviousStep(4, $event)"
          (observedFieldStatusChanged)="onObservedFieldStatusChanged($event)"
          (summaryRequested)="onStep5SummaryRequested($event)"
          (stepCompleted)="onStep5Completed($event)" />
      }

      @case (6) {
        <app-deploy-system-correction-step-6
          [existingData]="correctionFormData() ?? undefined"
          [observedFields]="observedFields()"
          [pendingObservedFields]="pendingObservedFields()"
          (goToPreviousStep)="goToPreviousStep(5, $event)"
          (observedFieldStatusChanged)="onObservedFieldStatusChanged($event)"
          (summaryRequested)="onStep6SummaryRequested($event)"
          (stepCompleted)="onStep6Completed($event)" />

        <div
          *ngIf="formCompletedMessage()"
          class="border-2 border-neutral-300 bg-neutral-100 rounded-sm px-6 py-4 mt-4">
          {{ formCompletedMessage() }}
        </div>
      }
    }
  </ng-container>
</div>
